import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'ChangeCustomerBillingGroup',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$root.$on('change_customer_billing_group_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
      });
    }
  },
  
}
